import { evelienAuthor, whoppahPublisher } from "@/common/utils/json-ld.utils";
import { CANONICAL_HOST } from "@/config";
import type { BrandStory } from "@/features/brand-story/brand-story.types";

/**
 * Article (authored by Evelien, the E-E-A-T signal) and FAQPage for a brand story. The
 * BreadcrumbList is emitted by the shared `Breadcrumb` component already.
 */
export const buildBrandStorySchemas = (
  story: BrandStory,
  path: string
): Record<string, unknown>[] => {
  const url = `${CANONICAL_HOST}${path}`;

  return [
    {
      "@context": "https://schema.org",
      "@type": "Article",
      mainEntityOfPage: { "@type": "WebPage", "@id": url },
      headline: story.seoTitle,
      description: story.seoDescription,
      about: { "@type": "Brand", name: story.name },
      ...(story.images.length > 0
        ? { image: story.images.map(image => image.src) }
        : {}),
      author: evelienAuthor,
      publisher: whoppahPublisher,
      inLanguage: "en",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: story.faq.map(item => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];
};
